const routes = {
  czechia: 'czechia',
  slovakia: 'slovakia',
  hungary: 'hungary',
  balticCountries: 'baltic-countries',
  fairValue: 'fair-value',
  digitalFairValue: 'digital-fair-value',
};

export default routes;
